(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-cart-upsell"] && !Shopify.designMode) return;
  try {
    
(function () {  
  async function insertSectionCartDrawer() {
    if (document.querySelector('#CartDrawer .cart-drawer-items-wrapper')) return;

    var cartDrawerItems = document.querySelector('#CartDrawer cart-drawer-items');
    if (!cartDrawerItems) return;

    if (cartDrawerItems.classList.contains('is-empty')) return;

    var wrapper = document.createElement('div');
    wrapper.classList.add('cart-drawer-items-wrapper');
    cartDrawerItems.parentNode.insertBefore(wrapper, cartDrawerItems);
    wrapper.appendChild(cartDrawerItems);

    const upsells = document.querySelector('#EG-cart-drawer-upsell-wrapper');
    wrapper.insertAdjacentHTML('beforeend', upsells.innerHTML);

    if (!document.querySelector('.EG-cart-drawer-upsell-list li')) {
      document.querySelector('#EG-cart-drawer-upsell').remove();  
    }
  }
  insertSectionCartDrawer();

  async function insertSectionCartPage() {
    const cartItems = document.querySelector('cart-items');
    if (!cartItems) return;

    const existingUpsells = document.querySelector('#MainContent #EG-cart-drawer-upsell');
    if (existingUpsells) {
      existingUpsells.remove();
    }

    const upsells = document.querySelector('#EG-cart-drawer-upsell-wrapper');
    cartItems.querySelector('.page-width').insertAdjacentHTML('beforeend', upsells.innerHTML);

    if (!document.querySelector('.EG-cart-drawer-upsell-list li')) {
      document.querySelector('#EG-cart-drawer-upsell').remove();  
    }
  }
  insertSectionCartPage();
  
  window.onChangeEGUpsellVariantSelector = function(select, event) {
    event.preventDefault();
    const imgSrc = select.options[select.selectedIndex].dataset.variantImg;

    if (imgSrc) {
      const img = select.closest('.EG-cart-drawer-upsell-list-item').querySelector('.EG-cart-drawer-upsell-list-item-left img');
      img.src = imgSrc;
    }
  }

  function listenCartDrawer() {
    const element = document.querySelector('cart-drawer');
    if (!element) return;

    let timer;
     
    const observer = new MutationObserver((mutations) => { 
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        const response = await fetch(window.location.href);
        const text = await response.text();
        const newDocument = new DOMParser().parseFromString(text, 'text/html');

        document.querySelector('#EG-cart-drawer-upsell-wrapper')
          .replaceWith(newDocument.querySelector('#EG-cart-drawer-upsell-wrapper'));

        insertSectionCartDrawer();
      }, 250);
    });

    observer.observe(element, {  
      attributes: true, 
      childList: true, 
      subtree: true
    });
  }
  listenCartDrawer();

  function listenCartPage() {
    const element = document.querySelector('#MainContent .cart__items');
    if (!element) return;

    let timer;
    
    const observer = new MutationObserver((mutations) => { 
      if (timer) clearTimeout(timer);

      timer = setTimeout(async () => {
        const response = await fetch(window.location.href);
        const text = await response.text();
        const newDocument = new DOMParser().parseFromString(text, 'text/html');

        document.querySelector('#EG-cart-drawer-upsell-wrapper')
          .replaceWith(newDocument.querySelector('#EG-cart-drawer-upsell-wrapper'));

        insertSectionCartPage();
      }, 250);
    });

    observer.observe(element, { 
      attributes: true, 
      childList: true, 
      subtree: true
    });
  }
  listenCartPage();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
